const domainSet = new Set([
  /* Default domains included */
  'aol',
  'att',
  'comcast',
  'facebook',
  'gmail',
  'gmx',
  'googlemail',
  'google',
  'hotmail',
  'hotmail',
  'hotmail',
  'hotmail',
  'mac',
  'me',
  'icloud',
  'mail',
  'msn',
  'live',
  'sbcglobal',
  'verizon',
  'yahoo',

  /* Other global domains */
  'iname',
  'inbox',
  'lavabit',
  'love' /* AOL */,
  'outlook',
  'pobox',
  'protonmail',
  'rocketmail' /* Yahoo */,
  'safe-mail',
  'wow' /* AOL */,
  'ygm' /* AOL */,
  'ymail' /* Yahoo */,
  'zoho',
  'yandex',

  /* United States ISP domains */
  'bellsouth',
  'charter',
  'cox',
  'earthlink',
  'juno',

  /* British ISP domains */
  'btinternet',
  'virginmedia',
  'blueyonder',
  'freeserve',
  'live',
  'ntlworld',
  'o2',
  'sky',
  'talktalk',
  'tiscali',
  'virgin',
  'wanadoo',
  'bt',

  /* Domains used in Asia */
  'sina',
  'qq',
  'naver',
  'hanmail',
  'daum',
  'natecom',

  /* French ISP domains */
  'hotmail',
  'live',
  'laposte',
  'wanadoo',
  'orange',
  'gmx',
  'sfr',
  'neuf',
  'free',

  /* German ISP domains */
  'gmx',
  'online',
  't-online' /* T-Mobile */,
  'web',

  /* Italian ISP domains */
  'libero',
  'virgilio',
  'hotmail',
  'aol',
  'tiscali',
  'alice',
  'live',
  'yahoo',
  'email',
  'tin',
  'poste',
  'teletu',

  /* Russian ISP domains */
  'mail',
  'rambler',
  'yandex',
  'ya',
  'list',

  /* Belgian ISP domains */
  'hotmail',
  'live',
  'skynet',
  'voo',
  'tvcablenet',
  'telenet',

  /* Argentinian ISP domains */
  'hotmail',
  'live',
  'yahoo',
  'fibertel',
  'speedy',
  'arnet',

  /* Domains used in Mexico */
  'yahoo',
  'live',
  'hotmail',
  'hotmail',
  'prodigy',

  /* Domains used in Brazil */
  'yahoo',
  'hotmail',
  'outlook',
  'uol',
  'bol',
  'terra',
  'ig',
  'itelefonica',
  'r7',
  'zipmail',
  'globo',
  'globomail',
  'oi',
])

function checkIfPopularDomain(fullDomain) {
  const domainWithoutTld = fullDomain.split('.')[0]
  const isEmpty = !domainWithoutTld || domainWithoutTld.length === 0
  const isEmail = fullDomain.includes('@')

  if (isEmpty) {
    throw new Error(
      `isPopularDomain cannot work on empty values: ${fullDomain}`
    )
  }
  if (isEmail) {
    throw new Error(`Invalid input for popular domain check`)
  }

  // ⚠️ We only check the domain part, without the tlds.
  // This may lead to over-invalidation.
  // But it's best to have support for those few cases than for security breaches
  return domainSet.has(domainWithoutTld)
}

export { checkIfPopularDomain, domainSet }
